// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  CustomerTriageCounts,
  customerTriageCountsResponseSchema,
} from '@/customer/api/triage-types';

export async function getTriageCustomerCounts(): Promise<CustomerTriageCounts> {
  const url = '/v1/customer-triage/counts';
  const response = await api.get(url);
  const result = await parseResponse(
    customerTriageCountsResponseSchema,
    response.data,
    {
      schemaName: 'TriageCustomerCounts',
      endpoint: url,
    }
  );
  return result.data;
}
